module.exports = __webpack_public_path__ + "img/矩形 13 拷贝.0fb72df0.png";